import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { BuilderComponent, builder, useIsPreviewing } from "@builder.io/react";

import "./builder/init";
import CredentialPage from "./components/CredentialPage/CredentialPage";
import ErrorPage from "./components/ErrorPage/ErrorPage";

const BuilderPage = () => {
  const isPreviewingInBuilder = useIsPreviewing();
  const [notFound, setNotFound] = useState(false);
  const [content, setContent] = useState(null);
  const location = useLocation();

  useEffect(() => {
    async function fetchContent() {
      const content = await builder
        .get("page", {
          url: location.pathname,
        })
        .promise();

      setContent(content);
      setNotFound(!content);

      if (content?.data.title) {
        document.title = content.data.title;
      }
    }
    fetchContent();
  }, [location.pathname]);

  if (notFound && !isPreviewingInBuilder) {
    return <p>404</p>;
  }

  return (
    <>
      <BuilderComponent model="page" content={content} />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/certifications/:badgeId" element={<CredentialPage />} />
        <Route path="/certifications" element={<ErrorPage />} />
        <Route path="*" element={<BuilderPage />} />
      </Routes>
    </Router>
  );
};

export default App;
